import { environment } from 'src/environments/environment';
import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
// [[PrimeNg]]
import { MessageService } from 'primeng/api';
// [[Providers]]
import { CustomerUserService } from 'src/project/services/panel/client/marketplace/customer/user/user.service';
import { CollectiveMarketplaceService } from '~services/collective/client/marketplace/marketplace.service';
import { CollectiveMarketplaceCartService } from '~services/collective/client/marketplace/cart/cart.service';
import { CollectiveMarketplaceCoreVisualBannerService } from '~services/collective/client/marketplace/core/visual/banner/banner.service';
import { ClientMarketplaceCoreProductService } from '~services/collective/client/marketplace/core/product/product.service';
// ]
// [[Interfaces/Models do Componente]]
import { Meta } from '~components/pagination/interfaces/pagination';
// ]
// [[Functions]]

// ]
@Component({
  selector: 'app',
  templateUrl: './component.html',
  styleUrls: ['./component.scss'],
})
export class SearchComponent implements OnInit {
  /**
   * Base de uso em Component
   */
  public environment = environment;
  messageProcess = false;
  messageIsError: any;
  profile: any;
  marketplace: any = null;
  cart: any = null;
  banners: any = null;
  banners_fnc_cta: any = null;

  constructor(
    /**
     * Serviços da Aplicação
     */
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    /**
     * PrimeNg
     */
    private messageService: MessageService,
    /**
     * Base de uso em Component
     */
    private userService: CustomerUserService,
    private collectiveMarketplaceService: CollectiveMarketplaceService,
    private collectiveMarketplaceCartService: CollectiveMarketplaceCartService,
    private collectiveMarketplaceCoreVisualBannerService: CollectiveMarketplaceCoreVisualBannerService, // #

    private clientMarketplaceCoreProductService: ClientMarketplaceCoreProductService
  ) /**
   * Services
   */
  {}

  ngOnInit() {
    this.ipBuildEcommerceDependencies();
  }

  /**
   * build ecommerce dependencies
   */
  ipBuildEcommerceDependencies() {
    /**
     * Base
     *
     * Request da base de uso.
     */
    // PROFILE
    this.userService.getUser().subscribe((Profile: any) => {
      if (Profile != null) {
        if (JSON.parse(Profile) != null) {
          this.profile = JSON.parse(Profile);
        }
      }
    });
    // MARKETPLACE
    this.collectiveMarketplaceService.getMarketplace().subscribe((Marketplace: any) => {
      if (Marketplace != null) {
        if (JSON.parse(Marketplace) != null) {
          this.marketplace = JSON.parse(Marketplace);
          /**
           *
           * CONFIGURAÇÕES ADICIONAIS DESTE `COMPONENTE`
           *
           */
          // SEO
          this.titleService.setTitle(this.marketplace.name);
        }
      }
    });
    // CART
    this.collectiveMarketplaceCartService.getCart().subscribe((Cart: any) => {
      if (Cart != null) {
        if (JSON.parse(Cart) != null) {
          this.cart = JSON.parse(Cart);
        }
      }
    });
    // BANNERS
    this.banners_fnc_cta = function (banner: any) {
      if (banner.url != '') {
        document.location = banner.url;
      }
      return false;
    };
    this.collectiveMarketplaceCoreVisualBannerService.getBanners().subscribe((Data: any) => {
      if (Data != null) {
        if (JSON.parse(Data) != null) {
          this.banners = JSON.parse(Data);
        }
      }
    });
    // SEARCH
    this.clientMarketplaceCoreProductService.getSearch().subscribe((Search: any) => {
      this.search = Search;
    });
    this.clientMarketplaceCoreProductService.getSearchResult().subscribe((searchResults: any) => {
      this.searchResults = searchResults;
    });

    // Força reload da busca quando é alterada `s?xx`
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.clientMarketplaceCoreProductServiceIndex(1);
      }
    });
  }

  ngAfterViewInit() {
    this.activatedRoute.params.subscribe((params) => {
      // Parâmetros base de URL
      if (typeof params['type'] !== 'undefined') {
        this.search.type = params['type'];
        if (this.search.type == 'category') {
          this.search.category = params['haystack'].replace(/-/g, ' ');
        }
        if (this.search.type == 'category-key') {
          this.search.category = params['haystack'];
        }
        if (this.search.type == 'salesman') {
          this.search.salesman = params['haystack'].replace(/-/g, ' ');
        }
        if (this.search.type == 'salesman-key') {
          this.search.salesman_url_handle = params['haystack'];
        }
        if (this.search.type == 'query') {
          this.search.query = params['haystack'].replace(/-/g, ' ');
        }
        if (this.search.type == 'sale') {
          this.search.product_is_sale = 'yes';
        }
      }

      // Parâmetros de Querystring
      this.activatedRoute.queryParams.subscribe((queryParams) => {
        if (queryParams['category']) {
          this.search.category = queryParams['category'];
        }
        if (queryParams['salesman']) {
          this.search.salesman = queryParams['salesman'];
        }
        if (queryParams['order_by']) {
          this.search.order_by = queryParams['order_by'];
        }
      });

      this.clientMarketplaceCoreProductServiceIndex(1);
    });
  }

  ngOnDestroy(): void {}

  // # /*
  // # |--------------------------------------------------------------------------
  // # | Search
  // # |--------------------------------------------------------------------------
  // # |
  // # */
  search: any = {
    per_page: 12,
    page: 1,
    client_marketplace_id: 1,
    query: '',
    start_at: new Date(),
  };

  searchResults: any;
  clientMarketplaceCoreProductServiceIndex(page: number) {
    this.search.page = page;
    var searchReplaySubject = this.search;
    this.clientMarketplaceCoreProductService.setSearch(searchReplaySubject);
  }

  clientMarketplaceCoreProductServiceCheckHaystackIsFiltering(type: string, item: any) {
    if (typeof this.search[type] === 'undefined') {
      return false;
    }
    return this.search[type].split(',').find((element: any) => element == item.index);
  }

  clientMarketplaceCoreProductServiceCheckHaystackCategory = [];

  clientMarketplaceCoreProductServiceChecCategorykHaystack(data: string) {
    // Category
    var categoryCheckBoxes: any = document.getElementsByClassName(data) as HTMLCollectionOf<HTMLElement>;
    for (var Box = 0; Box < categoryCheckBoxes.length; Box++) {
      if (categoryCheckBoxes[Box].checked) {
        this.clientMarketplaceCoreProductServiceCheckHaystackCategory.push(categoryCheckBoxes[Box].value);
      }
    }

    this.router.navigate([this.getUrlWithoutParams()], {
      queryParamsHandling: 'merge',
      queryParams: {
        category: this.clientMarketplaceCoreProductServiceCheckHaystackCategory.length > 0 ? this.clientMarketplaceCoreProductServiceCheckHaystackCategory.join(',') : '',
      },
    });

    this.clientMarketplaceCoreProductServiceIndex(1);
  }

  clientMarketplaceCoreProductServiceCheckHaystackSalesman = [];

  clientMarketplaceCoreProductServiceCheckSalesmanHaystack(data: string) {
    // Salesman
    if (data.includes('Salesman')) {
      var salesmanCheckBoxes: any = document.getElementsByClassName(data) as HTMLCollectionOf<HTMLElement>;
      for (var Box = 0; Box < salesmanCheckBoxes.length; Box++) {
        if (salesmanCheckBoxes[Box].checked) {
          this.clientMarketplaceCoreProductServiceCheckHaystackSalesman.push(salesmanCheckBoxes[Box].value);
        }
      }
    }

    this.router.navigate([this.getUrlWithoutParams()], {
      queryParamsHandling: 'merge',
      queryParams: {
        salesman: this.clientMarketplaceCoreProductServiceCheckHaystackSalesman.length > 0 ? this.clientMarketplaceCoreProductServiceCheckHaystackSalesman.join(',') : '',
      },
    });

    this.clientMarketplaceCoreProductServiceIndex(1);
  }

  getUrlWithoutParams() {
    let urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = {};
    urlTree.fragment = null;
    return urlTree.toString();
  }

  clearFilters() {
    this.router.navigate([this.getUrlWithoutParams()], {
      queryParamsHandling: 'merge',
      queryParams: {
        category: '',
        salesman: '',
      },
    });
  }

  menuOverlay() {
    let elem = document.getElementById('mobile-menu');
    if (elem.classList.contains('hidden')) {
      elem.classList.remove('hidden');
      elem.classList.add('block');
    } else if (elem.classList.contains('block')) {
      elem.classList.remove('block');
      elem.classList.add('hidden');
    }
  }

  filterOption(container: string, icon: string) {
    let categories = document.getElementById(container);
    let arrow = document.getElementById(icon);
    if (categories.classList.contains('hidden')) {
      categories.classList.remove('hidden');
      categories.classList.add('block');
      arrow.classList.remove('rotate-0');
      arrow.classList.add('rotate-180');
    } else if (categories.classList.contains('block')) {
      categories.classList.remove('block');
      categories.classList.add('hidden');
      arrow.classList.remove('rotate-180');
      arrow.classList.add('rotate-0');
    }
  }

  orderByOptions() {
    let container = document.getElementById('order-by');
    if (container.classList.contains('hidden')) {
      container.classList.remove('hidden');
      container.classList.add('block');
    } else if (container.classList.contains('block')) {
      container.classList.remove('block');
      container.classList.add('hidden');
    }
  }
}
